export default "__VITE_ASSET__nY1taI1J__"